import { useParams } from "react-router-dom";
import { BusinessFunctionType } from "src/generated/graphqlTypes";
import { TaskCatalogPage } from "src/routes/libraries/task-catalog/TaskCatalogPage";
import { TaskCatalogForm } from "src/routes/libraries/task-catalog/components/TaskCatalogForm";

/**
 * Disambiguates the shared `/libraries/task-catalog/:segment` URL shape.
 *
 * Legacy registered both `TaskCatalogForm` (`:idOrAdd`) and `TaskCatalogPage` (`:folderId`) as
 * sibling routes; folder deep-links (team codes / tag ids) must render the catalog page, while
 * `add` and task ids render the form.
 */
export function TaskCatalogSegmentPage() {
  const { idOrAdd } = useParams();
  if (idOrAdd && isTaskCatalogFolderSegment(idOrAdd)) {
    return <TaskCatalogPage />;
  }
  return <TaskCatalogForm />;
}

function isTaskCatalogFolderSegment(segment: string): boolean {
  return (
    segment.includes("globalPlanTag") || Object.values(BusinessFunctionType).includes(segment as BusinessFunctionType)
  );
}
